export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/muze-bg.png?a30d6d596e75337df8c462fcae4dde10";